module.exports = __webpack_public_path__ + "images/new_graphic_banner_default.png";